import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const SubsAdmin_NewSubsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [subsAttrs, setSubsAttrs] = useState({
    subsApp: '',
    description: '',
    igcUsername: '',
    receiverType: '',
    receiverHost: '',
    receiverUsername: '',
    receiverPassword: '',
    receiverSetting: '',
    status: 'SUBS_ST_STOPPED'      // When a subs is created, the initial status is always STOPPED.
  });


  // ### NEED TO FETCH FROM DB ###
  const statusOptions = [
    { key: "SUBS_ST_ACTIVE",    value: "SUBS_ST_ACTIVE" },
    { key: "SUBS_ST_SUSPENDED", value: "SUBS_ST_SUSPENDED" },
    { key: "SUBS_ST_STOPPED",   value: "SUBS_ST_STOPPED" }
  ];

  const receiverTypeOptions = [
    { key: "MQTT",      value: "MQTT" },
    { key: "WEBSOCKET", value: "WEBSOCKET" }
  ];


  // Initialize status
  useEffect(() => {
  }, [props]);


  // UI Functions

  const [errMsg, setErrMsg] = useState('');


  const onAttrsInputChange = (e) => {
    setSubsAttrs({ ...subsAttrs, [e.target.name]: e.target.value })
  }

  const onStatusSelect = (key, event) => {
    setSubsAttrs({ ...subsAttrs, status: key });
  };

  const onReceiverTypeSelect = (key, event) => {
    setSubsAttrs({ ...subsAttrs, receiverType: key });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate Receiver Setting to be valid JSON
    if (   (subsAttrs.receiverSetting !== '') 
        && (!testJSON(subsAttrs.receiverSetting))) {
        setErrMsg(t("I18N_ERR_Setting_need_valid_JSON"));
    } else {
      validateOtherFields();
    }

    return;
  }

  function validateOtherFields() {
    // Validate form inputs
    if (!subsAttrs.subsApp || subsAttrs.subsApp.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_subs_app"));
    } else if (subsAttrs.subsApp.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_subs_app") + 50);
    } else if (subsAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (!subsAttrs.igcUsername || subsAttrs.igcUsername.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_IGC_username"));
    } else if (subsAttrs.igcUsername.length > 60) {
      setErrMsg(t("I18N_ERR_Max_len_igc_uname") + 60);
    } else if (subsAttrs.receiverType === '') {
      setErrMsg(t("I18N_ERR_Need_Receiver_type"));
/*
    } else if (subsAttrs.receiverUsername === '') {
      setErrMsg(t("I18N_ERR_Need_Receiver_username"));
*/
    } else if (subsAttrs.receiverUsername.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_rec_uname") + 50);
/*
    } else if (subsAttrs.receiverPassword === '') {
      setErrMsg(t("I18N_ERR_Need_Receiver_password"));
*/
    } else if (subsAttrs.receiverPassword.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_rec_pwd") + 50);
    } else if (subsAttrs.receiverSetting === '') {
      setErrMsg(t("I18N_ERR_Need_Receiver_setting"));
    } else if (subsAttrs.status === '') {
      setErrMsg(t("I18N_ERR_Need_status"));
    } else {
      setErrMsg('');
      createSubs();
    }
  }

  const createSubs = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(subsAttrs));
    reqBody.receiverSetting = JSON.parse(subsAttrs.receiverSetting.trim());

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("subs", reqBody);

        resolve(res.data);

        if (res.status === 201) {
          // Return to list
          props.onUIMode('LIST')
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Subs")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Subs_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_App")}: *</Col>
              <Col>{t("I18N_Description")}:</Col>
              <Col>{t("I18N_IGC_username")}: *</Col>
              <Col>{t("I18N_Status")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="subsApp"
                       value={subsAttrs.subsApp} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                          value={subsAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="igcUsername"
                       value={subsAttrs.igcUsername} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!subsAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (statusOptions.find( ({ key }) => key === subsAttrs.status )).value)}
                  onSelect={onStatusSelect}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Receiver_type")}: *</Col>
              <Col>{t("I18N_Receiver_username")}:</Col>
              <Col>{t("I18N_Receiver_password")}: </Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!subsAttrs.receiverType ? t("common:I18N_DROPDOWN_PROMPT") :
                          t((receiverTypeOptions.find( ({ key }) => key === subsAttrs.receiverType )).value)}
                  onSelect={onReceiverTypeSelect}>
                  {receiverTypeOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverUsername"
                       value={subsAttrs.receiverUsername} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverPassword"
                       value={subsAttrs.receiverPassword} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col></Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '15px' }}>
              <Col sm={{span: 12}}>{t("I18N_Receiver_setting")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverSetting"
                          value={subsAttrs.receiverSetting} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>


            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Subs_add_dp_alarm_note")}</span>
            </Row>

            <hr className="solid" style={{ marginTop: '10px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default SubsAdmin_NewSubsView;
